import React from 'react';
import { PageHeader } from 'ui/shared/pageHeader';
import { Loading } from 'ui/shared/loading';

export const LoadingArea = () =>
    <div id="loading-area">
        <PageHeader title=""/>
        <div id="page-content">
            <Loading/>
        </div>
    </div>
;
